export const toLowerAndTrim = (str: string | undefined | null) => str?.toLowerCase().trim() || '';

export const normalizeStringForComparison = (str: string | undefined | null) =>
  str?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim() || '';
